import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { AppState } from "app/App Store/state";
import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";
import moment from "moment";
import { Leaddump } from "app/shared/models/leaddump.model";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 20,
    totalPages: 0,
    
  };
  currentStatus = 0;
  futureStatus = 0;
  pastStatus = 0;
  currentCount = 0;
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 20;
  selectedValue = "";
  // column header
  public columns = [
    { name: "Name", prop: "name" },
    { name: "Event Type", prop: "event_type" },
  ];

  // private
  private tempData = [];
  event_id: any;
  searchVal: any;
  @ViewChild("name") inputName;
  user_role: any;

  event_model = {
    name: "",
    event_date: "",
    location: "",
    event_tags: "",
    event_capacity: "",
    registration_deadline: "",
    event_type: "",
    event_status: "",
    speakers: [""],
    organizer: [""],
    participants: [""],
    notes: "",
    admin_notes: "",
    bussiness: "",
    budget: "",
    sprint: "",
    checklist: "",
    course:'',
    is_digital_certificate: false,
    isPopular: 'no',
  };
  event_image: any;
  emp_list = [];
  selected_Organizer = null;
  selected_Speaker = null;
  selected_user = null;
  type_list = [];
  selected_type = null;
  selected_type_name = "";

  tag_cat_id = "";
  users_list = [];
  status_list = [];
  imgUrl = environment.apiUrls.course_imageUrl;
  fileData: File;
  img_url: any;
  row_Participants = [];
  selectAll: boolean = false;
  selectAll_participant = [];

  guideline_data: any;

  business_list = [];
  selected_business = null;
  list_type_cat_id: any;
  list_type = [];
  selected_check_list = null;
  sprint_id: any;
  key_Values = [];
  sprint_data_id: any;
  checklist_data={}
  selected_check_list_name=null
  course_list =[]
  selected_course =null
  pageNumberSubscription : Subscription
  activeTab: string = "current";
  startDate:any = new Date(new Date(new Date().setDate(1)).setFullYear(new Date().getFullYear() - 1)).setHours(0, 0, 0, 0);
  endDate: any = new Date();
  currentUrl:any
  leadDump_model:any= new Leaddump
  
  // For isPopular functionality (similar to enrollment performer)
  popular_list = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' },
  ];
  popular_event: any = null;
  event_id_for_popular: any = null;
  constructor(
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public toastr: ToastrService,private store: Store<AppState>,
    private activateRoute: ActivatedRoute, private router: Router
  ) {
     this.currentUrl=this.activateRoute.snapshot.routeConfig.path
    this.user_role = JSON.parse(localStorage.getItem("user"));
    let setting_data = JSON.parse(localStorage.getItem("setting-record"));
    let key_data = setting_data.filter((item) => item.key == "Events");
    this.guideline_data = key_data[0]?._id;
    this.getTagCatList();
    this.getAllBusiness();
    this.getCheckListType();
    this.getCourseList()
    this.activateRoute.queryParamMap.subscribe((params) => {
      this.activeTab = params.get("status")
      let page = +params.get('page');
      this.setPage(page)
    });
    this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
    .subscribe(pageNumber => {
      this.page.pageNumber = pageNumber;
      if(pageNumber !==undefined){
        this.page.pageNumber = pageNumber -1
      }
      if(pageNumber === 0) this.page.pageNumber = 0
      
    });
    if(this.activeTab) this.activeStatusTab(this.page.pageNumber?this.page.pageNumber:1,this.activeTab)
    if (!this.activeTab && this.currentUrl ==='current-list') this.activeStatusTab(this.page.pageNumber ? this.page.pageNumber : 1, 'current')
    if (!this.activeTab && this.currentUrl ==='future-list') this.activeStatusTab(this.page.pageNumber ? this.page.pageNumber : 1, 'future')
    if (!this.activeTab && this.currentUrl ==='past-list') this.activeStatusTab(this.page.pageNumber ? this.page.pageNumber : 1, 'past')
    if (!this.activeTab) this.activeStatusTab(this.page.pageNumber ? this.page.pageNumber : 1, 'current')
    

  }

  ngOnInit(): void {
    this.setAndGetEventsStatus()
    this.getUsersList();
  }
  activeStatusTab(page, tab) {
    if(page<1){ page =1}
    this.activeTab = tab;
    this.startDate = moment(this.startDate).format("YYYY-MM-DD");
    this.endDate = moment(this.endDate).format("YYYY-MM-DD");
    if (this.activeTab !== '') {
      this.router.navigate(
        [],
        {
          relativeTo: this.activateRoute,
          queryParams: { status: this.activeTab, page: page,startDate:this.startDate,endDate:this.endDate },
          queryParamsHandling: 'merge'
        }
      );}
    
  }
   setAndGetEventsStatus() {
    this.activateRoute.queryParams.subscribe((params: any) => {
      this.activeTab = params?.status;
      this.getAllEvents(this.activeTab);
    });
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getAllEvents(status) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
    .getEventList(this.page.pageNumber + 1, this.limitRef,status,this.startDate,this.endDate)
    .subscribe((res: any) => {
      this.spinner.hide();
      this.rows = res.data.items;
      // this.page.totalPages = res.data.totalCount;
      this.currentCount = res.data.currentCount;
      this.pastStatus = res.data.pastStatus;
      this.currentStatus = res.data.currentStatus;
      this.futureStatus = res.data.futureStatus;
    });
  }
  editCategory(id: any) {}
  delete(id: any) {
    this.apiService.categoryDelete(id).subscribe((res: any) => {
      this.getAllEvents(this.activeTab);
    });
  }
  eventFilter(data: any) {
    let search = data;
    if (search) {
      this.apiService.filterEvent(search).subscribe((res: any) => {
        this.rows = res?.data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
    } else {
      this.getAllEvents(this.activeTab);
    }
  }
  resetFilter() {
    this.inputName.nativeElement.value = "";
    this.getAllEvents(this.activeTab);
  }
  pageChangeData(page: any) {
    this.router.navigate([], {
      relativeTo: this.activateRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.startDate = moment(this.startDate).format("YYYY-MM-DD");
    this.endDate = moment(this.endDate).format("YYYY-MM-DD");
      this.apiService
      .getEventList(page.offset + 1,this.limitRef,this.activeTab,this.startDate,this.endDate)
      .subscribe((res: any) => {
        this.setPage(page.offset + 1)
        this.rows = res.data.items;
        this.page.totalPages = res.data.totalCount;
        this.currentCount = res.data.totalCount;
        this.pastStatus = res.data.pastStatus;
        this.currentStatus = res.data.currentStatus;
        this.futureStatus = res.data.futureStatus;
        this.currentCount = res.data.currentCount
      });
  }

  eventDelete() {
    if (this.event_id) {
      this.apiService.deleteEvent(this.event_id).subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your imaginary file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.getAllEvents(this.activeTab);
        } else {
          swal.fire({
            icon: "error",
            title: "Erorr!",
            text: `${res.error}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    } else {
      this.toastr.error("something went wrong !!");
    }
  }
  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.event_id = id;
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2F8BE6",
        cancelButtonColor: "#F55252",
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then((result) => {
        if (result.value) {
          this.eventDelete();
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Your imaginary file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }

  // ==========================================

  openModal2(content) {
    this.event_id =''
    this.getAllEmp();
    const modalOptions: NgbModalOptions = {
      size: "lg",
      backdrop: "static",
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        this.event_model.name = ''
        this.event_model.location = ''
        this.event_model.budget = ''
        this.event_model.admin_notes = ''
        this.event_model.registration_deadline = ''
        this.event_model.notes = ''
        this.event_model.event_status = ''
        this.event_model.event_capacity = ''
        this.event_model.event_tags = ''
        this.event_model.event_date = ''
        this.event_model.isPopular = 'no'

        this.selected_Organizer = null;
        this.selected_Speaker = null;
        this.selected_user = null;
        this.selected_type = null;
        this.selected_business = null;
        this.selected_check_list = null;
        this.sprint_id = null;
        this.selected_course = null;
      },
      (reason) => {
      this.event_model.name = ''
      this.event_model.location = ''
      this.event_model.budget = ''
      this.event_model.admin_notes = ''
      this.event_model.registration_deadline = ''
      this.event_model.notes = ''
      this.event_model.event_status = ''
      this.event_model.event_capacity = ''
      this.event_model.event_tags = ''
      this.event_model.event_date = ''
      this.event_model.isPopular = 'no'

      this.selected_Organizer = null;
      this.selected_Speaker = null;
      this.selected_user = null;
      this.selected_type = null;
      this.selected_business = null;
      this.selected_check_list = null;
      this.sprint_id = null;
      this.selected_course = null;
      }
    );
  }
  getAllEmp() {
    this.apiService.getFullPartEmployeeList(1, 100).subscribe((res: any) => {
      this.emp_list = res?.items;
    });
  }
  getOrganizerId(event) {
    this.selected_Organizer;
  }
  getSpeakerId(event) {
    this.selected_Speaker;
    this.event_model.speakers =this.selected_Speaker;
  }
  getUsersList() {
    this.apiService.getUsers().subscribe((res: any) => {
      this.users_list = res?.data?.items;
    });
  }
  getUserId(event) {
    this.selected_user;
  }
  getTagCatList() {
    this.apiService.getAllCategory(1, 100).subscribe((res: any) => {
      let cat = res?.data?.items.find((item) => item.name == "event_type");
      this.tag_cat_id = cat._id;
      if (this.tag_cat_id) {
        this.getTypeList(this.tag_cat_id);
      }
      let cat_id = res?.data?.items?.find((item) => item?.name == "event_status");
      if (cat_id._id) {
        this.getStatusList(cat_id._id);
      }
    });
  }
  getTypeList(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.type_list = res.data;
    });
  }
  getStatusList(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      let status = res?.data?.find((item) => item.name == "current");
      this.event_model.event_status = status?._id;
      this.status_list = res?.data;
    });
  }
  getTypeId(event) {
    this.selected_type;
    this.event_model.event_type = this.selected_type;
    this.selected_type_name = event.name;
  }
  submit() {
    if (!this.event_id) {
      this.event_model.organizer = this.selected_Organizer;
      this.event_model.speakers = this.selected_Speaker;
      this.event_model.participants = this.selected_user;
      this.event_model.event_type = this.selected_type;
      this.event_model.bussiness = this.selected_business;
      this.event_model.checklist = this.selected_check_list;
      this.event_model.sprint = this.sprint_id;
      this.event_model.event_status = this.status_list.find(item => item.name === this.activeTab)?._id || '65045d0c6faeb7671ea4ce86';
      if(this.selected_course){
        this.event_model.course = this.selected_course
      }
      else delete this.event_model.course
      if (this.selected_check_list) {
        this.event_model.sprint = this.sprint_id;
        this.apiService.addEvent(this.event_model).subscribe((res: any) => {
          if (res?.statusCode === 200) {
            this.event_id = res?.data?._id;
            if (this.event_id) {
              this.uploadImage(this.event_id);
            }
            this.toastr.success(res.message);
            this.modalService.dismissAll();
          } else this.toastr.error(res.error);
        });
      } else {
        let newObject = Object.assign({}, this.event_model);
        delete newObject.sprint;
        this.apiService.addEvent(newObject).subscribe((res: any) => {
          if (res?.statusCode === 200) {
            this.event_id = res?.data?._id;
            if (this.event_id) {
              this.uploadImage(this.event_id);
            }
            this.toastr.success(res.message);
            this.modalService.dismissAll();
          } else this.toastr.error(res.error);
        });
      }
    }
    if (this.event_id) {
      if(this.selected_check_list_name &&  this.sprint_id ){
        this.event_model.organizer = this.selected_Organizer;
        this.event_model.speakers = this.selected_Speaker;
        this.event_model.participants = this.selected_user;
        this.event_model.event_type = this.selected_type;
        this.event_model.bussiness = this.selected_business;
        this.event_model.checklist = this.selected_check_list;
        this.event_model.sprint = this.sprint_id;
        this.event_model.checklist = this.selected_check_list
        this.event_model.sprint = this.sprint_id
        this.event_model.is_digital_certificate
        this.apiService.updateEvent(this.event_id,this.event_model).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.event_id =res?.data?._id
            if (this.event_id) {
              this.uploadImage(this.event_id);
            }
            this.toastr.success(res.message)
            this.modalService.dismissAll()
            this.getAllEvents(this.activeTab)
          }
          else this.toastr.error(res.error)
        })
      }
      if(!this.selected_check_list_name  ){
        this.event_model.is_digital_certificate
        const obj = this.event_model
        delete obj.sprint
        delete obj.checklist
        delete obj.participants
        this.apiService.updateEvent(this.event_id,obj).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.event_id =res?.data?._id
            if (this.event_id) {
              this.uploadImage(this.event_id);
            }
            this.toastr.success(res.message)
            this.modalService.dismissAll()
            this.getAllEvents(this.activeTab)          }
          else this.toastr.error(res.error)
        })
      }
    }
  }
  updateStatus(event_id, status_id) {
    let body = {
      event_status: status_id,
    };
    this.apiService.updateEvent(event_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success("status updated successfull!");
        this.modalService.dismissAll();
        this.getAllEvents(this.activeTab);
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  editEvent(content, id, data) {
    this.getAllEmp();
    this.event_id = id;
    this.event_image = data?.image;
    this.event_model.name = data?.name;
    this.event_model.location = data?.location;
    this.event_model.event_tags = data?.event_tags;
    this.event_model.event_date = data?.event_date;
    this.event_model.event_capacity = data?.event_capacity;
    this.event_model.admin_notes = data?.admin_notes;
    this.event_model.notes = data?.notes;
    this.event_model.registration_deadline = data?.registration_deadline;
    this.event_model.budget = data?.budget;
    this.sprint_id = data?.sprint[0]?.sprint;
    this.event_model.sprint = this.sprint_id;
    this.event_model.is_digital_certificate = data?.is_digital_certificate
    this.event_model.isPopular = data?.isPopular || 'no';
    this.event_model.event_status = data?.event_status[0]?._id
    this.selected_check_list = data?.sprint[0]?.checklist[0]?._id;
    this.event_model.checklist = this.selected_check_list;

    this.selected_business = data?.bussiness[0]?._id;
    this.event_model.bussiness = this.selected_business;

    this.selected_Organizer = data?.organizer?.map((item) => item);
    this.event_model.organizer = this.selected_Organizer;

    this.selected_Speaker = data?.speakers?.map((item) => item);
    this.event_model.speakers = this.selected_Speaker;

    this.selected_user = data?.participants?.map((item) => item._id);
    this.event_model.participants = this.selected_user;

    this.selected_type = data?.event_type[0]?._id;
    this.event_model.event_type = this.selected_type;
    this.selected_course = data?.course?._id
    this.event_model.course = this.selected_course
    
    const modalOptions: NgbModalOptions = {
      size: "lg",
      backdrop:'static'
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        this.event_model.name = ''
        this.event_model.location = ''
        this.event_model.budget = ""
        this.event_model.admin_notes = ''
        this.event_model.registration_deadline = ''
        this.event_model.notes = ''
        this.event_model.event_status = ''
        this.event_model.event_capacity = ''
        this.event_model.event_tags = ''
        this.event_model.event_date = ''
        this.event_model.isPopular = 'no'

  
        this.selected_Organizer = null;
        this.selected_Speaker = null;
        this.selected_user = null;
        this.selected_type = null;
        this.selected_business = null;
        this.selected_check_list = null;
        this.sprint_id = null;
      },
      (reason) => {
        this.event_model.name = ''
        this.event_model.location = ''
        this.event_model.budget = ""
        this.event_model.admin_notes = ''
        this.event_model.registration_deadline = ''
        this.event_model.notes = ''
        this.event_model.event_status = ''
        this.event_model.event_capacity = ''
        this.event_model.event_tags = ''
        this.event_model.event_date = ''
        this.event_model.isPopular = 'no'
  
        this.selected_Organizer = null;
        this.selected_Speaker = null;
        this.selected_user = null;
        this.selected_type = null;
        this.selected_business = null;
        this.selected_check_list = null;
        this.sprint_id = null;
      }
    );
  }
  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.img_url = reader.result;
      };
    }
  }
  uploadImage(id) {
    let formData = new FormData();
    formData.append("image", this.fileData);
    this.apiService.uploadCover(id, formData).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.getAllEvents(this.activeTab);
      } else this.toastr.error(res.error);
    });
  }
  openModalParticipants(content, data) {
    this.getEventByIdd(data._id);
    this.event_id = data._id;
    this.leadDump_model.title = data.name;
    this.selectAll = false;
    this.selectAll_participant = [];
    const modalRef = this.modalService.open(content);
    modalRef.result.then(
      (result) => {
        this.selectAll = false;
        this.selectAll_participant = [];
      },
      (reason) => {
        this.selectAll = false;
        this.selectAll_participant = [];
      }
    );
  }
  getEventByIdd(id) {
    this.apiService.getEventById(id).subscribe((res: any) => {
      this.row_Participants = res?.data[0]?.participants.map((item) => ({
        ...item,
        selected: item.is_approved === true,
      }));
    });
  }
  selectAllParticipants() {
    for (const item of this.row_Participants) {
      item.selected = this.selectAll;
      this.selectAll_participant.push(item?._id);
    }
  }

  updateSelectAll(id) {
    this.selectAll = this.row_Participants.every((item) => item.selected);
    this.selectAll_participant = id;
  }
  approveParticipant() {
    let body = {
      approved_by: this.selectAll_participant,
    };
    this.apiService.updateEvent(this.event_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success("approved successfull!");
        this.sendEmail(this.event_id);
        this.modalService.dismissAll();
        this.getAllEvents(this.activeTab);
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  sendEmail(id) {
    let body = {
      eventId: id,
    };
    this.apiService.sendMailCertificate(body).subscribe((res: any) => {});
  }
  getAllBusiness() {
    this.apiService.getBusinessList(1, 2000).subscribe((res: any) => {
      this.business_list = res.data.items;
    });
  }
  getBusinessId(event) {
    this.event_model.bussiness=this.selected_business
  }

  getCheckListType() {
    this.apiService
      .getTagByTagCatgoryId("65268dbf37d5731c9401d3fe")
      .subscribe((res: any) => {
        this.list_type_cat_id = res?.data?.filter(
          (item) => item.name == "quick"
        );
        if (this.list_type_cat_id) {
          this.getCheckList();
        }
      });
  }
  getCheckList() {
    this.apiService
      .getAllChecklist(1, 100, this.list_type_cat_id[0]?._id)
      .subscribe((res: any) => {
        this.list_type = res?.data?.items;
      });
  }
  getCheckListId(event) {
    this.event_model.checklist = this.selected_check_list
    this.selected_check_list_name = event.name
    if (this.selected_check_list) {
      this.apiService
        .getSprintByChecklistId(this.selected_check_list)
        .subscribe((res: any) => {
          this.sprint_id = res?.data[0]?.sprint[0]._id;
        });
    }
  }
  openCheclistPopup(content, data, sprintId) {
    this.key_Values = Object.entries(data[0].data);
    this.sprint_data_id = data[0]._id;
    this.sprint_id = sprintId;
    // const modalOptions: NgbModalOptions = {
    //   size: 'lg'
    // };
    const modalRef = this.modalService.open(content);
    modalRef.result.then(
      (result) => {
        this.sprint_id = "";
        this.sprint_data_id = "";
        this.key_Values = [];
      },
      (reason) => {
        this.sprint_id = "";
        this.sprint_data_id = "";
        this.key_Values = [];
      }
    );
  }
  updateCheck() {
    let obj_data = Object.fromEntries(this.key_Values as any[]);
    let body = {
      data: obj_data,
    };
    this.apiService
      .updateSprint(this.sprint_id, this.sprint_data_id, body)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success("updated successfully!");
          this.modalService.dismissAll();
          this.getAllEvents(this.activeTab);
        } else {
          this.toastr.error(res.error);
        }
      });
  }
  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl',
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  setFocus(event) {
    this.event_model.event_tags = event.html;
  }
  deleteParticipant(id): void {
   
    let body = {
      approved_by: [id],
    };
    this.apiService.removeApprovedStudentEvent(this.event_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success("delete successfull!");
        this.getEventByIdd(this.event_id)
        
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  digitalCertificate(data) {
    this.event_model.is_digital_certificate = data;
  }
  copyEvents(id){
    this.apiService.copyEvent(id).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success('Copy Event successfull!')
        this.getAllEvents(this.activeTab);
      }
      else this.toastr.error(res?.error)
    })
  }
  getCourseList(){
    this.apiService.getCourseList(1,this.limitRef).subscribe((res:any)=>{
      this.course_list = res?.data?.items
    })
  }
  getCourseId(event){
    this.event_model.course = this.selected_course

  }
  
  // For isPopular functionality (similar to enrollment performer)
  selectPopular(value) {
    this.popular_event = value;
  }
  
  onPopularChange(event: any) {
    // Convert checkbox boolean to string values
    this.event_model.isPopular = event.target.checked ? 'yes' : 'no';
  }
  
  submitPopular() {
    let body = {
      isPopular: this.popular_event
    }
    this.apiService.updateEvent(this.event_id_for_popular, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Popular status updated successfully');
        this.getAllEvents(this.activeTab);
        this.modalService.dismissAll();
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  
  openPopularModal(content, row) {
    this.event_id_for_popular = row._id;
    // Set the popular_event value BEFORE opening modal with proper null/undefined handling
    this.popular_event = row?.isPopular || 'no';
    
    const modalRef = this.modalService.open(content);
    
    modalRef.result.then((result) => {
      // Modal closed
    }, (reason) => {
      // Modal dismissed
    });
  }
  changeDate() {
    
    let activetab = this.activeTab;
    if (activetab !== '') {
      this.router.navigate(
        [],
        {
          relativeTo: this.activateRoute,
          queryParams: { status: activetab, page: this.page.pageNumber,startDate:this.startDate,endDate:this.endDate },
          queryParamsHandling: 'merge'
        }
      );
     
      this.apiService
        .getEventList(this.page.pageNumber, this.limitRef,this.activeTab,this.startDate,this.endDate)
        .subscribe((res: any) => {
          this.setPage(this.page.offset + 1);
          this.rows = res.data.items;
          this.page.totalPages = res.data.totalCount;
            this.currentCount = res.data.totalCount;
        this.pastStatus = res.data.pastStatus;
        this.currentStatus = res.data.currentStatus;
        this.futureStatus = res.data.futureStatus;
        this.currentCount = res.data.currentCount
        });
    }
    
  }
  addDump() {
    let users: any[] = []
    users= this.row_Participants.map(item => item._id)
    // console.log('==>>', users)
    this.leadDump_model.action ="63e39be02052e0098e18dfde"
	  this.leadDump_model.stage = "63e391a22052e0098e18de7f";
    this.leadDump_model.user = users
    this.apiService.addLeadDump(this.leadDump_model).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Added successfully!');
        this.modalService.dismissAll()
      }
      else this.toastr.error(res.error)
    })
  }
}
